<template>
  <DialogFull :data="dialogSettings" @close="onClose">
    <template v-slot:dialog.body>
      <JobInfoBar v-if="currentBooking" :title="currentBooking.title" />
      <div class="container col-md-8 col-sm-12">
        <div>
          <v-img
            :src="require('@/assets/svg/dont-meet-requirements.svg')"
            alt="You do not meet the mandatory requirements"
            class="mb-5"
            height="140"
            contain
          />
          <h2 class="mb-2 d-flex justify-center text-center">
            {{ title }}
          </h2>
          <span class="secondary-text d-flex justify-center text-center mb-5">
            {{ subtitle }}
          </span>
        </div>
        <div class="d-flex justify-center">
          <PrimaryButton @click.native="onClose">
            Okay
          </PrimaryButton>
        </div>
      </div>
    </template>
  </DialogFull>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import { GET_CURRENT_BOOKING } from "@/store/modules/bookings/getters";
import DialogFull from "@/components/common/DialogFull";
import JobInfoBar from "@/views/profile/components/JobInfoBar";

const { mapGetters } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "NewAccountErrorTemplate",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    onClose: {
      type: Function,
      default: function() {
        this.$router.push("dashboard");
      }
    }
  },
  components: {
    PrimaryButton,
    DialogFull,
    JobInfoBar
  },
  computed: {
    ...mapGetters({
      currentBooking: GET_CURRENT_BOOKING
    }),
    dialogSettings() {
      return {
        dialog: true,
        title: "New Application"
      };
    }
  }
};
</script>

<style lang="scss"></style>
